<template>
    <div class="info-list">
        <Header/>
        <div class="user_reg">
            <div class="r_tit" style="margin-bottom:16px">登录我的账号</div>
            <div class="l-r-content">
                <LoginModule />
            </div>
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
import LoginModule from './components/loginModule'
export default {
    data() {
        return {
            currentStep:1,
            level:1,
        }
    },
    components:{
        LoginModule
    },
    created() {
    },
    methods: {
        changeStep(val){
            this.currentStep = Number(val);
        }
    },
}
</script>
<style lang="scss" scoped>
.title{
    font-size: 20px;
}

</style>
